import { FEATURE_FLAGS } from '../../../../featureFlags';
import Bot from './Index.vue';
import { frontendURL } from '../../../../helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/agent-bots'),
      name: 'agent_bots',
      component: Bot,
      meta: {
        featureFlag: FEATURE_FLAGS.AGENT_BOTS,
        permissions: ['administrator'],
      },
    },
  ],
};
